import { getBillingExplorerCsvPossibleColumnsSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/csv/possible-columns/getBillingExplorerCsvPossibleColumnsSelector";
import { ResourceExplorerPossibleColumns } from "@/services/cloudchipr.api";
import { RootState } from "@/store/store";

export const billingExplorerCsvPossibleColumnsDataSelector = (
  state: RootState,
): ResourceExplorerPossibleColumns | undefined => {
  return getBillingExplorerCsvPossibleColumnsSelector(state)?.data;
};
